import { useMutation, useQueryClient } from '@tanstack/react-query'

import { postRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { MarkNotificationAsReadResponse } from 'src/shared/schemas/stream/notification'

const markAllNotificationsAsRead = async () => {
  try {
    const response = await postRequest<MarkNotificationAsReadResponse>(`/feeds/notifications/mark-all-as-read`)
    if (!response) {
      throw new Error('Failed to mark all notifications as read')
    }
    return response
  } catch (error) {
    throw new Error(`Failed to mark all notifications as read | ${error}`)
  }
}

export const useMarkAllNotificationsAsRead = () => {
  const queryClient = useQueryClient()

  return useMutation({
    ...queries.notifications.markAsRead,
    mutationFn: markAllNotificationsAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queries.notifications._def })
    },
  })
}
